import React, { Fragment } from 'react';
import Auth from '../../Auth/Auth';
import { connect } from 'react-redux'
import { DefaultButton, PrimaryButton, ContextualMenuItemType, Toggle, Modal, Icon } from '@fluentui/react';
import { DirectionalHint, IconButton } from '@fluentui/react';
import { Panel, PanelType } from '@fluentui/react';
import Profile from './Profile'
import { profilePage, toggleTheme } from "../../actions"
import Cookies from 'universal-cookie';
import $ from 'jquery'
import { Person20Regular, Headset20Regular, PersonFeedback20Regular, DarkTheme20Regular, ArrowForward20Regular, QuestionCircle20Regular, BookOpen24Regular, Chat24Regular, Open20Regular, ChevronRight20Regular } from '@fluentui/react-icons'

const menuIconStyle = { marginRight: 8, display: 'inline-flex', verticalAlign: 'middle' };
export class ProfileDropdown extends React.Component {
    constructor(props) {
        super(props);
        this.auth = new Auth();
        this.state = {
            open: false,
            img: null,
            accountOpen: this.props.profilePage,
            showThemesPanel: false,
            showHelpPanel: false,
            theme: this.props.theme
        };
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.theme !== this.props.theme) {
            this.setState({
                theme: nextProps.theme
            });
        }
    }

    componentDidMount() {
        this.setState({ phoneNumber: this.props.user.phoneNumber, img: this.props.user.userImg, })

        let items = [
            {
                key: '1',
                text: 'Profile',
                iconProps: {},
                onRenderIcon: () => <Person20Regular style={menuIconStyle} />,
                onClick: () => this.handleClickOpen(1)
            },
            {
                key: 'help',
                text: 'Get help now',
                iconProps: {},
                onRenderIcon: () => <QuestionCircle20Regular style={menuIconStyle} />,
                onClick: () => this.toggleHelpPanel()
            },
            {
                key: '6',
                text: 'Contact Support',
                iconProps: {},
                onRenderIcon: () => <Headset20Regular style={menuIconStyle} />,
                onClick: () => this.handleClickOpen(6)
            },
            {
                key: '7',
                text: 'Feature Request',
                iconProps: {},
                onRenderIcon: () => <PersonFeedback20Regular style={menuIconStyle} />,
                onClick: () => this.handleClickOpen(7)
            }
        ]

        if (this.props.user.userType == '1' || this.props.user.userType == '2') {
            items.push({
                key: '8',
                text: 'Theme',
                iconProps: {},
                onRenderIcon: () => <DarkTheme20Regular />,
                itemType: ContextualMenuItemType.Header,
                onRenderContent: () => {
                    return <div className="displayflex spacebetween aligncenter width100">
                        <div className="displayflex aligncenter pt5">
                            <DarkTheme20Regular style={{ marginLeft: 4, marginRight: 14, color: 'var(--fui-neutralPrimary)' }} />
                            <span style={{ fontWeight: 400, fontSize: 14, color: 'var(--fui-neutralPrimary)' }}>Theme</span>
                        </div>
                        <Toggle className="mt5 mr10" label="" defaultChecked={this.state.theme == "dark"} onChange={this._onChange} />
                    </div>
                },
                onClick: () => { return false }
            },)
        }
        items.push({
            key: '9',
            text: 'Log Out',
            iconProps: {},
            onRenderIcon: () => <ArrowForward20Regular style={menuIconStyle} />,
            onClick: () => this.handleLogoutClick()
        })
        this.setState({
            items: items
        });
    }


    componentWillReceiveProps(nextProps) {
        if (nextProps.profilePage != this.props.profilePage) {
            this.setState({ accountOpen: nextProps.profilePage })
        }
    }

    handleClickOpen = (tab) => {
        this.props.dispatch(profilePage(tab))
    };

    handleClose = () => {
        this.props.dispatch(profilePage(null))
    };

    handleClick = (event) => {
        event.preventDefault();
        this.setState({
            open: true,
            anchorEl: event.currentTarget
        });
    };

    handleLogoutClick = () => {
        this.auth.logout();
    };


    _renderMenuList = (menuListProps, defaultRender) => {
        
        return (
            <div>
                {defaultRender(menuListProps)}
            </div>
        );
    };

    _renderProfile = (menuListProps, defaultRender) => {
        return (
            <div className="dropdown-toggle" >
                <span className="username">{this.props.user.email}</span>
                <div class="icon-object">
                    {!this.props.user.userImg &&

                        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18"><path d="M9,1a8,8,0,1,0,8,8A8,8,0,0,0,9,1Zm4.71,13.5c-.75-1.11-2.45-1.15-2.78-2.41a3.68,3.68,0,0,0,1-1.54,1.43,1.43,0,0,0,.82-1.38c0-.43-.18-.73-.48-.7,0-2.33-1-3.43-2.41-3.71-.06-.19-.28-.32-.66-.32-2.08,0-3.38,1.19-3.39,4-.3,0-.48.27-.48.7a1.43,1.43,0,0,0,.82,1.38,3.68,3.68,0,0,0,1,1.54c-.33,1.26-2,1.3-2.78,2.41a7.25,7.25,0,1,1,9.42,0Z" /></svg>
                    }
                    {this.props.user.userImg &&
                        <img className="profile-img" src={process.env.REACT_APP_CDN_URL + this.props.user.userImg} />
                    }
                </div>
            </div>
        );
    }

    onOuterClick = (e) => {
        //
        //e.preventDefault();
        //e.stopPropagation();
        //return false;
    }

    toggleThemesPanel = () => {
        this.setState({
            showThemesPanel: !this.state.showThemesPanel
        });
    }

    toggleHelpPanel = () => {
        this.setState({
            showHelpPanel: !this.state.showHelpPanel
        });
    }

    openHelpCenter = () => {
        window.open('https://app.teamslyapp.com/help-center', '_blank', 'noopener,noreferrer');
        this.setState({ showHelpPanel: false });
    }

    loadCrisp = () => {
        if (!window.crispScriptLoaded) {
            window.$crisp = [];
            window.CRISP_WEBSITE_ID = "3b751c0d-1914-4e9e-b135-799afe29efb0";
            const s = document.createElement("script");
            s.src = "https://client.crisp.chat/l.js";
            s.async = 1;
            document.getElementsByTagName("head")[0].appendChild(s);
            window.crispScriptLoaded = true;
        }
    }

    openSupportChat = () => {
        this.loadCrisp();
        const tryOpen = (attempt = 0) => {
            if (window.$crisp && typeof window.$crisp.push === 'function') {
                window.$crisp.push(["do", "chat:show"]);
                window.$crisp.push(["do", "chat:open"]);
            } else if (attempt < 20) {
                setTimeout(() => tryOpen(attempt + 1), 150);
            }
        };
        tryOpen();
        this.setState({ showHelpPanel: false });
    }

    toggleThemeBtn = (theme) => {
        this.props.dispatch(toggleTheme(theme));
        this.setState({
            theme: theme
        });
        const cookies = new Cookies();
        cookies.set('theme', theme, { path: '/' });
    }

    _onChange = (ev, checked) => {
        let theme = checked ? 'dark' : 'light';
        $('body').removeClass(`theme-dark`)
        $('body').removeClass(`theme-light`)
        $('body').addClass(`theme-${theme}`)

        this.props.dispatch(toggleTheme(theme));
        this.setState({
            theme: theme
        });
        const cookies = new Cookies();
        cookies.set('theme', theme, { path: '/' });
        return false;
    }

    onRenderOption = (option) => {
        
        return (
            <div>
                {option.data && option.data.icon && (
                    <Icon iconName={option.data.icon} aria-hidden="true" title={option.data.icon} />
                )}
                <span>{option.text}</span>
            </div>
        );
    };

    render() {
        return (
            <Fragment>
                <ul className="builder-navbar-menu nav navbar-nav">
                    <li className="profile-dropdown">
                        <PrimaryButton
                            styles={{
                                root: { height: '100%', borderRadius: 0,padding:'0 6px', backgroundColor: 'transparent !important', border:'none' },
                                label: { color: 'rgba(0, 0, 0, 0.87)' },
                                menuIcon: { marginLeft: 10, fontWeight: '600 !important', fontSize: '12px', color: 'rgba(0, 0, 0, 0.87)' }
                            }}
                            onRenderText={this._renderProfile}
                            menuProps={{
                                onRenderOption: this.onRenderOption,
                                items: this.state.items,
                                directionalHint: DirectionalHint.bottomRightEdge,
                                shouldFocusOnContainer: true,
                                calloutProps: {
                                    calloutMaxHeight: 365,
                                    className: 'profile-options',
                                    styles: {
                                        root: {
                                            border: '1px solid rgba(var(--palette-neutral-100), 0.18)',
                                            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 2.4px 5.4px 0px, rgba(0, 0, 0, 0.0807) 0px 1.2px 1.6px 0px',
                                            borderRadius: 5, overflow: 'hidden'
                                        },
                                    },
                                }
                            }}
                        />

                    </li>
                   

                </ul>
                <Modal
                    isOpen={this.state.accountOpen}
                    className={`profile-modal ${this.props.theme === 'dark' ? 'theme-dark' : ''}`}
                    onDismiss={this.handleClose}
                    isBlocking={false}
                    containerClassName="profile-modal-container"
                >

                    <Profile closePanel={this.handleClose} />
                </Modal>
                {this.state.showHelpPanel &&
                    <Panel className="assign-shift-dialog" isOpen={this.state.showHelpPanel} isLightDismiss={true} onDismiss={this.toggleHelpPanel} type={PanelType.custom} customWidth={'450px'}>
                        <div className="py40 px10">
                            <h2 style={{ fontSize: 24, fontWeight: 700, marginBottom: 24, marginTop: 0 }}>Get help setting up</h2>
                            <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 12 }}>Always available</div>
                            <div
                                onClick={this.openHelpCenter}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    background: '#fff',
                                    border: '1px solid #e5e7eb',
                                    borderRadius: 10,
                                    padding: '16px 18px',
                                    marginBottom: 14,
                                    cursor: 'pointer',
                                    boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
                                }}
                            >
                                <BookOpen24Regular style={{ marginRight: 16, color: 'var(--themePrimary2)', flexShrink: 0 }} />
                                <div style={{ flex: 1 }}>
                                    <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>Teamsly support</div>
                                    <div style={{ fontSize: 13, color: '#6b7280' }}>Browse our help center for guides and answers</div>
                                </div>
                                <Open20Regular style={{ marginLeft: 12, color: 'var(--themePrimary2)', flexShrink: 0 }} />
                            </div>
                            <div
                                onClick={this.openSupportChat}
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    background: '#fff',
                                    border: '1px solid #e5e7eb',
                                    borderRadius: 10,
                                    padding: '16px 18px',
                                    cursor: 'pointer',
                                    boxShadow: '0 1px 2px rgba(0,0,0,0.04)'
                                }}
                            >
                                <Chat24Regular style={{ marginRight: 16, color: 'var(--themePrimary2)', flexShrink: 0 }} />
                                <div style={{ flex: 1 }}>
                                    <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 4 }}>Chat with us</div>
                                    <div style={{ fontSize: 13, color: '#6b7280' }}>Talk to our support team in real time</div>
                                </div>
                                <ChevronRight20Regular style={{ marginLeft: 12, color: 'var(--themePrimary2)', flexShrink: 0 }} />
                            </div>
                        </div>
                    </Panel>
                }
                {this.state.showThemesPanel &&
                    <Panel className="assign-shift-dialog show-header theme-panel transparent-overlay" headerText="Choose your theme" isOpen={this.state.showThemesPanel} isLightDismiss={true} onDismiss={this.toggleThemesPanel} type={PanelType.custom} customWidth={'400px'}>
                        <div className="p0 employee-schedule" >
                        <div className="theme-management-group">
                            <div className="theme-management-container displayflex">
                                <div className={`theme-tile-container ${this.state.theme == 'dark' ? 'selected' : ''}` } onClick={() => this.toggleThemeBtn('dark')}>
                                    <div className="theme-tile">
                                        <div className="theme-tile-sections" style={{ backgroundColor: 'rgb(32, 31, 30)'}}>
                                            <div className="theme-header" style={{ background: 'rgb(32, 31, 30)', boxShadow: 'rgba(255, 255, 255, 0.95) 0px 1px 0px', zIndex: 1}}>
                                                <div className="theme-button" style={{ backgroundColor: 'rgb(152, 198, 255)'}}></div>
                                            </div>
                                            <div className="theme-nav" style={{ backgroundColor: 'rgb(59, 58, 57)'}}></div>
                                            <div className="theme-background" style={{ backgroundColor: 'rgb(32, 31, 30)' }}>
                                                <div className="theme-text long" style={{ backgroundColor: 'rgba(255, 255, 255, 0.95)' }}></div>
                                                <div className="theme-text" style={{ backgroundColor: 'rgba(255, 255, 255, 0.95)' }}></div>
                                                <div className="theme-text short" style={{ backgroundColor: 'rgba(255, 255, 255, 0.95)' }}></div>
                                                <div className="theme-text long" style={{ backgroundColor: 'rgba(255, 255, 255, 0.95)' }}></div>
                                                <div className="theme-button wide" style={{ backgroundColor: 'rgb(0, 91, 161)' }}></div>
                                            </div>
                                        </div>
                                        <div className="theme-name">Dark</div>
                                    </div>
                                </div>
                                <div className={`theme-tile-container ${this.state.theme == 'light' ? 'selected' : ''}`} onClick={() => this.toggleThemeBtn('light') }>
                                    <div className="theme-tile">
                                        <div className="theme-tile-sections" style={{ backgroundColor: 'rgb(255, 255, 255)' }}>
                                            <div className="theme-header" style={{ backgroundColor: 'rgb(255, 255, 255)', boxShadow: 'rgba(0, 0, 0, 0.9) 0px 1px 0px', zIndex: 1 }}>
                                                <div className="theme-button" style={{ backgroundColor: 'rgb(0, 120, 212)' }}></div>
                                            </div>
                                            <div className="theme-nav" style={{ backgroundColor: 'rgb(234, 234, 234)' }}></div>
                                            <div className="theme-background" style={{ backgroundColor: 'rgb(255, 255, 255)' }}>
                                                <div className="theme-text long" style={{ backgroundColor: 'rgba(0, 0, 0, 0.9)' }}></div>
                                                <div className="theme-text" style={{ backgroundColor: 'rgba(0, 0, 0, 0.9)' }}></div>
                                                <div className="theme-text short" style={{ backgroundColor: 'rgba(0, 0, 0, 0.9)' }}></div>
                                                <div className="theme-text long" style={{ backgroundColor: 'rgba(0, 0, 0, 0.9)' }}></div>
                                                <div className="theme-button wide" style={{ backgroundColor: 'rgb(0, 120, 212)' }}></div>
                                            </div>
                                        </div>
                                        <div className="theme-name">Light</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </div>
                    </Panel>
                }
            </Fragment>
        );
    }
}
const mapStateToProps = state => ({
    user: state.userProfile,
    profilePage: state.rootReducer.profilePage,
    facilityId: state.appState.product.facility.facilityID,
    theme: state.rootReducer.theme
});

export default connect(mapStateToProps)(ProfileDropdown);



